import React from "react";
import "./App.css";
import "./styles/clutch-cricket.css";
import "./styles/dark-mode.css";
import "./styles/cricket-elements.css";

// Context
import { ThemeProvider } from "./context/ThemeContext";

// Components
import Navigation from "./components/Navigation";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import JourneyTimeline from "./components/JourneyTimeline";
import ProgramsSection from "./components/ProgramsSection";
import GallerySection from "./components/GallerySection";
import TestimonialsSection from "./components/TestimonialsSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import FloatingButtons from "./components/FloatingButtons";

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <Navigation />
        <HeroSection />
        <AboutSection />
        <JourneyTimeline />
        <ProgramsSection />
        <GallerySection />
        <TestimonialsSection />
        <ContactSection />
        <Footer />
        <FloatingButtons />
      </div>
    </ThemeProvider>
  );
}

export default App;
